export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditSessie.vue?vue&type=template&id=126deb36&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Sessies/EditSessie.vue?vue&type=template&id=126deb36&
// module id = 389
// module chunks = 0